import { createColumnHelper } from "@tanstack/react-table";

import { Checkbox } from "../Checkbox/Checkbox";

const columnHelper = createColumnHelper<any>();

export const selectColumn = columnHelper.display({
  id: "select",
  size: 60,
  header: ({ table }) => (
    <Checkbox
      name="dataTableSelectAll"
      checked={table.getIsAllRowsSelected() ? true : table.getIsSomeRowsSelected() ? "indeterminate" : false}
      onClick={table.getToggleAllPageRowsSelectedHandler()}
    />
  ),
  cell: ({ row }) => (
    <Checkbox
      name={`dataTableRow-${row.id}`}
      checked={row.getIsSelected()}
      onClick={(e) => e.stopPropagation()}
      onCheckedChange={row.getToggleSelectedHandler()}
    />
  )
});
